import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {YzUploadFileComponent} from './yz-upload-file/yz-upload-file.component';
import {SharedModule} from "../shared.module";
import {LoadingModule} from "../loading/loading.module";
import {YzFileCarouselComponent} from './yz-file-carousel/yz-file-carousel.component';
import {YzFileShowComponent} from './yz-file-show/yz-file-show.component';

const COMPONENTS = [
  YzUploadFileComponent,
  YzFileCarouselComponent,
  YzFileShowComponent
];

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [...COMPONENTS,],
  entryComponents: [...COMPONENTS],
  imports: [SharedModule, LoadingModule],
  exports: [...COMPONENTS]
})
export class UploadFileModule {
}
